import React, { useState, useEffect, useRef, useContext } from "react";
import {
  FiSearch,
  FiTrash2,
  FiChevronDown,
  FiArrowUp,
  FiCheck,
} from "react-icons/fi";
import "../../../assets/css/admin/dashboard/adminbuyers/allbuyer.css";
import AdminMasterLayout from "layouts/AdminMasterLayout";
import AppContext from "context/AppContext";
import axios from "axios";

// ─── Status config ────────────────────────────────────────────
const STATUS_CONFIG = {
  Active: { bg: "#dcfce7", color: "#166534", dot: "#22c55e" },
  Inactive: { bg: "#f3f4f6", color: "#374151", dot: "#9ca3af" },
  Banned: { bg: "#fee2e2", color: "#991b1b", dot: "#ef4444" },
  Suspended: { bg: "#fef3c7", color: "#92400e", dot: "#f59e0b" },
};

const STATUS_OPTIONS = ["Active",  "Suspended"];

// ─── Status Dropdown ──────────────────────────────────────────
const StatusDropdown = ({ userId, current, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const cfg = STATUS_CONFIG[current] || STATUS_CONFIG.Active;

  return (
    <div className="buyers-status-dd" ref={ref}>
      {/* Pill Button */}
      <button
        className="buyers-status-pill"
        style={{ background: cfg.bg, color: cfg.color }}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="buyers-status-dot" style={{ background: cfg.dot }} />
        {current}
        <FiChevronDown
          size={11}
          className={`buyers-dd-arrow ${open ? "buyers-dd-arrow--open" : ""}`}
        />
      </button>

      {/* Dropdown Menu */}
      {open && (
        <div className="buyers-status-menu">
          {STATUS_OPTIONS.map((s) => {
            const c = STATUS_CONFIG[s];
            return (
              <button
                key={s}
                className={`buyers-status-opt ${s === current ? "buyers-status-opt--active" : ""}`}
                onClick={() => {
                  onChange(userId, s);
                  setOpen(false);
                }}
              >
                <span
                  className="buyers-status-dot"
                  style={{ background: c.dot }}
                />
                <span>{s}</span>
                {s === current && (
                  <FiCheck size={12} className="buyers-opt-check" />
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

// ─── Main Component ───────────────────────────────────────────
const AllBuyers = () => {
  const { baseUrl, baseUrlForFiles,authToken } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [totalUsers,setTotalUsers]=useState("");
  const [activeUsers,setActiveUsers]=useState("");
  const [blockedUsers,setBlockedUsers]=useState("");
  const [propertiesListed,setPropertiesListed]=useState("");
  const [selectedDate, setSelectedDate] = useState('all');
  const [animateCards, setAnimateCards] = useState(false);
  const [error, setError] = useState();
  const [usersData, setUsersData] = useState([]);
  const statsData = [
    { id: 1, title: 'total Users', value: totalUsers, change: '+1.7%', changeText: 'than last month' },
    { id: 2, title: 'Active Users', value: activeUsers, change: '+1.7%', changeText: 'than last month' },
    { id: 3, title: 'Blocked Users', value: blockedUsers, change: '+8.5%', changeText: 'than last month' },
    { id: 4, title: 'Properties Listed', value: propertiesListed, change: '+12.3%', changeText: 'this last week' },
  ];

  const allBuyerStats = () => {
    setLoading(true);
    axios.get(`${baseUrl}/admin/buyers/buyerStatsCard`,{
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        }
      })
      .then((response) => {
        console.log(response.data);
        setTotalUsers(response.data.totalUsers);
        setActiveUsers(response.data.activeUser);
        setBlockedUsers(response.data.blockedUsers);
        setPropertiesListed(response.data.propertyListed);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
  };

  useEffect(() => {
    allBuyerStats();
  }, []);


  const changeBuyerStatus = (userId, newStatus) => {
    const formData = new FormData();
    formData.append("buyer_id", userId);
    formData.append("status", newStatus);

    axios
      .post(`${baseUrl}/admin/buyers/changeBuyerStatus`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log("resposne called", response.data);
        if (response.data.success == true) {
          setUsersData((prev) =>
            prev.map((u) =>
              u.id === userId ? { ...u, status: newStatus } : u,
            ),
          );
        } else if (response.data.succes == false) {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const deleteBuyersByAdmin = (user) => {
    console.log("**********", user);
    const formData = new FormData();
    formData.append("id", user.id);
    axios
      .post(`${baseUrl}/admin/buyers/deleteBuyerByAdmin`, formData,{
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        }
      })
      .then((response) => {
        console.log(response.data.message);
        viewAllBuyers();
      })
      .catch((error) => console.log(error));
  };

  const viewAllBuyers = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/buyers/viewAllBuyers`,{
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        }
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setUsersData(response.data.buyers);
          setLoading(false);
        } else if (response.data.succes == false) {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    viewAllBuyers();
  }, []);

  useEffect(() => {
    setAnimateCards(true);
  }, []);

  // ── Status change ──────────────────────────────────────────
  const handleStatusChange = (userId, newStatus) => {
    setUsersData((prev) =>
      prev.map((u) => (u.id === userId ? { ...u, status: newStatus } : u)),
    );
  };

  const handleDelete = (userId) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      setUsersData((prev) => prev.filter((u) => u.id !== userId));
    }
  };

  const handleApply = () => {
    console.log("Filters applied:", { selectedStatus, selectedDate });
  };

  // ── Filter ─────────────────────────────────────────────────
  const filtered = usersData.filter((u) => {
    const q = searchTerm.toLowerCase();
    const matchSearch =
      !q ||
      u.name.toLowerCase().includes(q) ||
      u.email.toLowerCase().includes(q) ||
      u.username.toLowerCase().includes(q);
    const matchStatus =
      selectedStatus === "all" || u.status.toLowerCase() === selectedStatus;
    return matchSearch && matchStatus;
  });

  return (
    <AdminMasterLayout pageTitle="All Buyers">
      <div className="all-users-page">
        {/* Header */}
        {/* <div className="users-page-header">
          <h1 className="users-page-title">All Buyers</h1>
        </div> */}

        {/* Stats */}
        <div className="users-stats-grid">
          {statsData.map((stat, i) => (
            <div
              key={stat.id}
              className={`users-stat-card ${animateCards ? "animate" : ""}`}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="users-stat-label">{stat.title}</div>
              <div className="users-stat-main-value">{stat.value}</div>
              {/* <div className="users-stat-footer">
                <span className="users-stat-change-icon"><FiArrowUp size={12} /></span>
                <span className="users-stat-change-value">{stat.change}</span>
                <span className="users-stat-change-text">{stat.changeText}</span>
              </div> */}
            </div>
          ))}
        </div>

        {/* Filters */}
        {/* <div className="users-filters-section">
          <div className="users-filters-left">
            <div className="users-search-wrapper">
              <FiSearch className="users-search-icon" />
              <input
                type="text"
                placeholder="Search by ID, Name, Email"
                className="users-search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="users-filter-dropdown">
              <select
                className="users-filter-select"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="all">Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
                <option value="banned">Banned</option>
                <option value="suspended">Suspended</option>
              </select>
              <FiChevronDown className="users-dropdown-icon" size={14} />
            </div>

            <div className="users-filter-dropdown">
              <select
                className="users-filter-select"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              >
                <option value="all">Date</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>
              </select>
              <FiChevronDown className="users-dropdown-icon" size={14} />
            </div>
          </div>

          <div className="users-filters-right">
            <button className="users-apply-btn" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div> */}

        {/* Table */}
        <div className="users-table-card">
          <div className="users-table-wrapper">
            <table className="users-users-table">
              <thead>
                <tr>
                  <th>
                    <div className="users-th-content">
                      <span>user Name</span>
                    </div>
                  </th>
                  {/* <th><div className="users-th-content"><span>Last Name</span></div></th> */}
                  <th>
                    <div className="users-th-content">
                      <span>Email</span>
                    </div>
                  </th>
                  <th>
                    <div className="users-th-content">
                      <span>Location</span>
                    </div>
                  </th>
                  <th>
                    <div className="users-th-content">
                      <span>Phone</span>
                    </div>
                  </th>
                  {/* <th>Username</th> */}
                  <th>Status</th>

                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="buyers-loader-row">
                      <div className="buyers-loader-wrapper">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        ></span>
                        <span className="buyers-loader-text">
                          Loading Buyers Records...
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : filtered.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="buyers-empty-row">
                      No buyers found.
                    </td>
                  </tr>
                ) : (
                  filtered.map((user, idx) => (
                    <tr
                      key={user.id}
                      className="users-table-row"
                      style={{ animationDelay: `${idx * 0.05}s` }}
                    >
                      {/* Name */}
                      <td>
                        <div className="users-info">
                          <img
                            src={`${baseUrlForFiles}${user?.profileImage}`}
                            alt={user.name}
                            className="users-avatar"
                          />
                          <span className="users-name">
                            {user.firstName}
                            {user.lastName}
                          </span>
                        </div>
                      </td>
                      {/*  <td>
                       <div className="users-info">
                          {/* <img src={user.avatar} alt={user.name} className="users-avatar" />
                          <span className="users-name"
                          >{user.lastName}</span>
                        </div>
                      </td> */}

                      {/* Email */}
                      <td className="users-email">{user.email}</td>
                      {/* location */}
                      <td className="users-email">{user.location}</td>
                      {/* phone */}
                      <td className="users-date">{user.phonenumber}</td>

                      {/* Username */}
                      {/* <td className="users-username">{user.username}</td> */}

                      {/* Status — dropdown pill */}
                      <td>
                        <StatusDropdown
                          userId={user.id}
                          current={user.status}
                          onChange={changeBuyerStatus}
                        />
                      </td>

                      {/* Date */}
                      {/* <td className="users-date">{user.joinedDate}</td> */}

                      {/* Actions — only Delete */}
                      <td>
                        <div className="users-action-buttons">
                          <button
                            className="users-action-btn users-delete-btn"
                            onClick={() => deleteBuyersByAdmin(user)}
                            title="Delete User"
                          >
                            <FiTrash2 size={20} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminMasterLayout>
  );
};

export default AllBuyers;
